import { assertNever } from "@msys/common";
import { Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";
import { getCrmLinkingStatus } from "../getCrmLinkingStatus.js";
import { CrmCompanyConnectedLabel } from "./CrmCompanyConnectedLabel.js";
import { CrmCompanyInviteButton } from "./CrmCompanyInviteButton.js";

interface Props {
  crmCompanyId: string;
  linkedSystemOrganisationId?: string | null;
  isInvited: boolean;
  refetchQueries: string[];
}

export function CrmCompanyLinkingStatus({
  crmCompanyId,
  linkedSystemOrganisationId,
  isInvited,
  refetchQueries,
}: Props) {
  const { t } = useTranslate("CrmOrganisations");

  const status = getCrmLinkingStatus({ linkedSystemOrganisationId, isInvited });

  switch (status) {
    case "linked":
      return <CrmCompanyConnectedLabel />;
    case "invited":
      return (
        <Typography variant="caption" align="center" color="text.disabled">
          {t("Invitation sent")}
        </Typography>
      );
    case "notInvited":
      return (
        <RestrictedByOrganisationPermissionWithDebug permission="organisation_integration_update">
          <Stack direction="row" sx={{ justifyContent: "center" }}>
            <CrmCompanyInviteButton
              crmCompanyId={crmCompanyId}
              refetchQueries={refetchQueries}
              label={t("Invite")}
              size="small"
            />
          </Stack>
        </RestrictedByOrganisationPermissionWithDebug>
      );
    default:
      assertNever(status);
  }
}
